import { render } from "./BankPayButtonPaymentDetails.vue?vue&type=template&id=668b1e87&scoped=true&ts=true"
import script from "./BankPayButtonPaymentDetails.vue?vue&type=script&lang=ts"
export * from "./BankPayButtonPaymentDetails.vue?vue&type=script&lang=ts"

import "./BankPayButtonPaymentDetails.vue?vue&type=style&index=0&id=668b1e87&scoped=true&lang=css"

import exportComponent from "/app/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-668b1e87"]])

export default __exports__